import { verifyPasscode } from 'modules/shop/widgets/ModalCheckPassCode';
import HeaderActionButton, { HeaderActionButtonType } from '../../HeaderActions/HeaderActionButton';
import ModalCashDeposit, { useModalCashDepositRef } from './ModalCashDeposit';

const CashierCashDeposit = () => {
  const modalRef = useModalCashDepositRef();
  const handleOpen = () => verifyPasscode(() => modalRef.current?.open(), 'ADMIN');
  return (
    <>
      <HeaderActionButton
        type={HeaderActionButtonType.CASH_DEPOSIT}
        onClick={handleOpen}
      />
      <ModalCashDeposit ref={modalRef} />
    </>
  );
};

export default CashierCashDeposit;
